import React, { useEffect, useState } from "react";
import { getAccessToken } from "../utils/Auth";
import Constants from "../utils/Constants";
import axios from "axios";
import Notification from "./Notification";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Select } from "@material-ui/core";
import { Button, Typography, InputLabel, makeStyles } from "@material-ui/core";
import { formatDate, getTimeDeltaHuman } from "../utils/Functions";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import { MenuItem, Switch } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import { ValidatedTextField, anyErrors } from "../utils/ValidatedTextField";
import DetectionModeSlider from "./DetectionModeSlider";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionDetails from "@mui/material/AccordionDetails";

let http_str = 'https://'
let list_url = http_str.concat(Constants.apiHost, '.', Constants.domainName, '/api/v1/lists')

const useStyles = makeStyles(theme => ({
    dialog: {
        backgroundColor: '#333333',
        color: '#CCCCCC',
        '& .MuiFormLabel-root.Mui-disabled': {
            color: 'red',
        },
    },
    dialogTitleBar: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
    },
    dialogConfirm: {
        backgroundColor: '#149616',
        color: '#CCCCCC',
        '&:hover': {
            backgroundColor: '#1be01e',
            color: '#333333',
        },
        '&:disabled': {
            color: '#CCCCCC',
        }
    },
    dialogNeutral: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
        '&:hover': {
            backgroundColor: '#5861fc',
            color: '#333333',
        },
        '&:disabled': {
            color: '#CCCCCC',
        }
    },
    dialogWarning: {
        backgroundColor: '#d42842',
        color: '#CCCCCC',
        '&:hover': {
            backgroundColor: '#fc0d31',
            color: '#333333',
        },
        '&:disabled': {
            color: '#CCCCCC',
        }
    },
    dialogWidget: {
        margin: '5px',
    },
    inputRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        verticalAlign: 'baseline',
        '& .MuiSelect-filled': {
            color: 'black',
            backgroundColor: '#555555',
        },
        '& .MuiSelect-iconFilled': {
            color: 'black',
        },
    },
    primaryColor: {
        color: '#000',
        backgroundColor: '#111'
    },
    whiteColor: {
        color: "#EEE",
    },
    hide: {
        display: 'none',
    },
    spaced: {
        margin: '10px',
    }
}))

const sensitivityOptions = [
  {
    value: 21,
    label: 'Very Low',
  },
  {
    value: 15,
    label: 'Low',
  },
  {
    value: 9,
    label: 'Normal',
  },
    {
    value: 5,
    label: 'High',
  },
  {
    value: 1,
    label: 'Very High',
  },
];

export default function PoliciesDialog({ mode, open, onClose, onSave, item }) {
    const classes = useStyles()
    const [enable_ransomnote_value_x, set_enable_ransomnote_value_x] = useState(1)
    const [formData, setFormData] = useState({
        pk: null,
        policy_name: '',
        ransomware: '',
        ransomnote: '',
        magic_bytes: '',
        safe: '',
        blocked: '',
        sensitivity: 1,
        detection_mode_blocked: 1,
        detection_mode_safe: 1,
        detection_mode_ransomware: 1,
        detection_mode_email: 1,
        detection_mode_magic_bytes: 1,
        detection_mode_ransomnote: 1,
        detection_mode_common_extensions: 1,
        detection_mode_file_lock: 1,
        detection_mode_entropy_extensions: 1,
        enable_ransomnote_detection: true,
        enable_ransomnote_value: 1,
        enable_entropy_detection: false,
        action_suspend_user: false,
        action_suspend_access_key: false,
        action_block_ip: false,
        action_collect_forensics: true,
        action_kill_process: false,
        action_delete_version: false,
        action_enforce_reauth_sso: false,
    })


    const [listData, setListData] = useState([])
    let title = 'Policies'

    const [error, setError] = useState([])
    const [isRequiredFieldEmpty, setIsRequiredFieldEmpty] = useState(true)


    if (mode === 'add') {
        title = 'Add Policy'
        item = null
    }
    else if (mode === 'edit') {
        title = 'Edit Policy: ' + item?.pk
    }

    const getLists = async () => {
        let url = list_url + '?limit=25'
        const http_headers = { "Content-Type": "application/json", "Authorization": await getAccessToken() }
        console.log('url: ' + url)
        await axios
            .get(url, { headers: http_headers })
            .then(res => {
                const items = res.data['lists'];
                console.log(items);
                setListData(items)
            })
            .catch(err => {
                if (err.response) {
                    console.log('bad response from server: ' + err.response)
                } else if (err.request) {
                    console.log('no response from server: ' + err.request)
                } else {
                    console.log(err)
                }
                Notification(`Error while fetching ${url}. ${err}`, 'error');
            })
    }

    const handleChange = (event) => {
        const { name, value } = event.target
        console.log(name + ": " + value)
        setFormData((prevFormData) => ({ ...prevFormData, [name]: value }))
    };

    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target
        console.log(name + ": " + event.target.checked)
        setFormData((prevFormData) => ({ ...prevFormData, [name]: checked }))
    };

    const handleDetectionSliderChange = (event, newValue, target) => {
        let val = Array.isArray(newValue) ? newValue[0] : newValue
        // val = coerceMode(val)
        setFormData(prev => (prev[target] === val ? prev : { ...prev, [target]: val }))
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        onSave(formData)
    }

    function detection_section() {
        // This is for detection specific fields
        return (
            <>
                <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="detections-content"
                      id="detections-header"
                      sx={{ bgColor: "#555555" }}
                    >
                    Detections
                    </AccordionSummary>
                    <AccordionDetails className={classes.dialog}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <div style={{
                                    width: '300px',
                                    height: 0,
                                    visibility: 'hidden',
                                    overflow: 'hidden',
                                }}
                                />
                            </Grid>
                            <Grid item xs={3} className={classes.inputRow}>
                                <InputLabel className={classes.dialog}>Block List:</InputLabel>
                            </Grid>
                            <Grid item xs={3} className={classes.inputRow}>
                                <DetectionModeSlider
                                    name="detection_mode_blocked"
                                    value={formData.detection_mode_blocked}
                                    handleSliderChange={handleDetectionSliderChange}
                                />
                            </Grid>
                            <Grid item xs={3} className={classes.inputRow}>
                                <InputLabel className={classes.dialog}>Safe List:</InputLabel>
                            </Grid>
                            <Grid item xs={3} className={classes.inputRow}>
                                <DetectionModeSlider
                                    name="detection_mode_safe"
                                    value={formData.detection_mode_safe}
                                    handleSliderChange={handleDetectionSliderChange}
                                    />
                            </Grid>
                            <Grid item xs={3} className={classes.inputRow}>
                                <InputLabel className={classes.dialog}>Ransomware Extensions:</InputLabel>
                            </Grid>
                            <Grid item xs={3} className={classes.inputRow}>
                                <DetectionModeSlider
                                    name="detection_mode_ransomware"
                                    value={formData.detection_mode_ransomware}
                                    handleSliderChange={handleDetectionSliderChange}
                                    />
                            </Grid>
                            {/* <Grid item xs={3} className={classes.inputRow}>
                                <InputLabel className={classes.dialog}>Filename Contains Emails:</InputLabel>
                            </Grid>
                            <Grid item xs={3} className={classes.inputRow}>
                                <DetectionModeSlider
                                    name="detection_mode_email"
                                    value={formData.detection_mode_email}
                                    handleSliderChange={handleDetectionSliderChange}
                                    />
                            </Grid> */}
                            <Grid item xs={3} className={classes.inputRow}>
                                <InputLabel className={classes.dialog}>Invalid File Format:</InputLabel>
                            </Grid>
                            <Grid item xs={3} className={classes.inputRow}>
                                <DetectionModeSlider
                                    name="detection_mode_magic_bytes"
                                    value={formData.detection_mode_magic_bytes}
                                    handleSliderChange={handleDetectionSliderChange}
                                    />
                            </Grid>
                            <Grid item xs={3} className={classes.inputRow}>
                                <InputLabel className={classes.dialog}>File Entropy Check:</InputLabel>
                            </Grid>
                            <Grid item xs={3} className={classes.inputRow}>
                                <DetectionModeSlider
                                    name="detection_mode_entropy_extensions"
                                    value={formData.detection_mode_entropy_extensions}
                                    handleSliderChange={handleDetectionSliderChange}
                                />
                            </Grid>
                            <Grid item xs={3} className={classes.inputRow}>
                                <InputLabel className={classes.dialog}>Detect Ransom notes:</InputLabel>
                            </Grid>
                            <Grid item xs={3} className={classes.inputRow}>
                                <DetectionModeSlider
                                    name="detection_mode_ransomnote"
                                    value={formData.detection_mode_ransomnote}
                                    handleSliderChange={handleDetectionSliderChange}
                                    />
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </>
        )
    }

    function responses_section() {
        // This is for response specific fields
        return (
            <>
                <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="responses-content"
                      id="responses-header"
                      sx={{ bgColor: "#555555" }}
                    >
                    Responses
                    </AccordionSummary>
                    <AccordionDetails className={classes.dialog}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <div style={{
                                    width: '300px',
                                    height: 0,
                                    visibility: 'hidden',
                                    overflow: 'hidden',
                                }}
                                />
                        </Grid>
                            <Grid item xs={3} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Collect Forensics (safe):</InputLabel>
                        </Grid>
                        <Grid item xs={3} className={classes.inputRow}>
                            <Switch
                                name="action_collect_forensics"
                                checked={formData.action_collect_forensics}
                                onChange={handleCheckboxChange}
                            />
                        </Grid>
                            <Grid item xs={3} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}></InputLabel>
                        </Grid>
                        <Grid item xs={3} className={classes.inputRow}>
                        </Grid>
                        <Grid item xs={3} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Suspend User Account:</InputLabel>
                        </Grid>
                        <Grid item xs={3} className={classes.inputRow}>
                            <Switch
                                name="action_suspend_user"
                                checked={formData.action_suspend_user}
                                onChange={handleCheckboxChange}
                            />
                        </Grid>
                        <Grid item xs={3} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Suspend Access Key:</InputLabel>
                        </Grid>
                        <Grid item xs={3} className={classes.inputRow}>
                            <Switch
                                name="action_suspend_access_key"
                                checked={formData.action_suspend_access_key}
                                onChange={handleCheckboxChange}
                            />
                        </Grid>
                        <Grid item xs={3} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Stop Processes:</InputLabel>
                        </Grid>
                        <Grid item xs={3} className={classes.inputRow}>
                            <Switch
                                name="action_kill_process"
                                checked={formData.action_kill_process}
                                onChange={handleCheckboxChange}
                            />
                        </Grid>
                        <Grid item xs={3} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Block IP:</InputLabel>
                        </Grid>
                        <Grid item xs={3} className={classes.inputRow}>
                            <Switch
                                name="action_block_ip"
                                checked={formData.action_block_ip}
                                onChange={handleCheckboxChange}
                            />
                        </Grid>

                        {/* Commented out "Restore Files" option */}
                        {/* <Grid item xs={3} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Restore Files</InputLabel>
                        </Grid>
                        <Grid item xs={2} className={classes.inputRow}>
                            <Switch
                                name="action_delete_version"
                                checked={formData.action_delete_version}
                                onChange={handleCheckboxChange}
                            />
                        </Grid> */}
                        {/* Commented out "Reauth to SSO" option */}
                        {/* <Grid item xs={3} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Enforce Reauth to SSO</InputLabel>
                        </Grid>
                        <Grid item xs={3} className={classes.inputRow}>
                            <DetectionModeSlider
                                name="action_enforce_reauth_sso"
                                value={formData.action_enforce_reauth_sso}
                                onChange={handleCheckboxChange}
                            />
                        </Grid> */}
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </>
        )
    }

    useEffect(() => {
        getLists()
        if (item) {
            setFormData(prev => {
                const updates = {}
                let changed = false

                // Basic scalar fields
                const scalar = [
                    'pk','policy_name','ransomware','ransomnote','magic_bytes',
                    'safe','blocked','sensitivity',
                    'enable_ransomnote_detection','enable_ransomnote_value','enable_entropy_detection',
                    'action_suspend_user','action_suspend_access_key','action_block_ip',
                    'action_kill_process','action_delete_version','action_collect_forensics','action_enforce_reauth_sso'
                ]
                scalar.forEach(f => {
                    if (item[f] !== undefined && item[f] !== prev[f]) {
                        updates[f] = item[f]
                        changed = true
                    }
                })

                // Detection mode field names actually bound to sliders
                const detectionFields = [
                    'blocked','safe','ransomware','email','magic_bytes',
                    'ransomnote','common_extensions','file_lock'
                ]
                detectionFields.forEach(name => {
                    const key = 'detection_mode_' + name
                    const raw = item[key]
                    if (raw !== undefined) {
                        const val = raw
                        if (val !== prev[key]) {
                            updates[key] = val
                            changed = true
                        }
                    }
                })

                if (!changed) return prev
                return { ...prev, ...updates }
            })
            console.log('item: ' + JSON.stringify(item))
            console.log('formData: ' + formData)
        }
    }, [item, open]);

    // Fetch lists once per open
    useEffect(() => {
        if (open) getLists()
    }, [open])

    useEffect(() => {
        if (formData.policy_name.trim() === '') {
            setIsRequiredFieldEmpty(true)
        } else {
            setIsRequiredFieldEmpty(false)
        }
    }, [formData.policy_name])

    return (
        <Dialog
            open={open}
            onClose={onClose}
            sx={{ width: 600 }}
            fullWidth={true}
            maxWidth="sm"
        >
            <DialogTitle className={classes.dialogTitleBar}>{title}</DialogTitle>
            <DialogContent className={classes.dialog}>
                <DialogContentText className={classes.dialog}>
                    <Grid container spacing={2}>
                        <Grid item xs={4} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Name:</InputLabel>
                        </Grid>
                        <Grid item xs={7}>
                            <ValidatedTextField
                                id='name'
                                name='policy_name'
                                label='Name*'
                                value={formData.policy_name}
                                onChange={handleChange}
                                variant={"outlined"}
                                classes={{ root: classes.whiteColor }}
                                sx={{ width: 300 }}
                                inputProps={{ style: { color: "#FFF" } }}
                                InputLabelProps={{ style: { color: "#AAA" } }}
                                error={error}
                                setError={setError}
                                mode='default'
                                required='required'
                            />
                        </Grid>
                        <Grid item xs={4} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Safe List:</InputLabel>
                        </Grid>
                        <Grid item xs={7} className={classes.inputRow}>
                            <Select
                                name="safe"
                                label="Safe Extensions"
                                variant="outlined"
                                value={formData.safe}
                                onChange={handleChange}
                                classes={{ root: classes.whiteColor, icon: classes.whiteColor }}
                                style={{ minWidth: 225 }}
                            >
                                <MenuItem key='0' value=''>none</MenuItem>
                                {listData.map((item) =>
                                    <MenuItem key={item.pk} value={item.pk}>{item.list_name}</MenuItem>)}
                            </Select>
                        </Grid>
                        <Grid item xs={4} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Block List:</InputLabel>
                        </Grid>
                        <Grid item xs={7} className={classes.inputRow}>
                            <Select
                                name="blocked"
                                label="Block List"
                                variant="outlined"
                                value={formData.blocked}
                                onChange={handleChange}
                                classes={{ root: classes.whiteColor, icon: classes.whiteColor }}
                                style={{ minWidth: 225 }}
                            >
                                <MenuItem key='0' value=''>none</MenuItem>
                                {listData.map((item) =>
                                    <MenuItem key={item.pk} value={item.pk}>{item.list_name}</MenuItem>)}
                            </Select>
                        </Grid>
                        <Grid item xs={4} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Sensitivity:</InputLabel>
                        </Grid>
                        <Grid item xs={7} className={classes.inputRow}>
                            <Select
                                name="sensitivity"
                                label="Sensitivity"
                                variant="outlined"
                                value={formData.sensitivity}
                                onChange={handleChange}
                                classes={{ root: classes.whiteColor, icon: classes.whiteColor }}
                                style={{ minWidth: 225 }}
                            >
                                {sensitivityOptions.map((item) =>
                                    <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>)}
                            </Select>
                        </Grid>
                        {detection_section()}
                        {responses_section()}
                        <Grid item xs={8}>
                            <Typography variant='subtitle2' className={classes.dialogWidget} component={'span'}>Created: {formatDate(item ? item.created : new Date())} ({getTimeDeltaHuman(item ? item.created : new Date())})</Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant='subtitle2' className={classes.dialogWidget} component={'span'}>Modified: {formatDate(item ? item.modified : new Date())} ({getTimeDeltaHuman(item ? item.modified : new Date())})</Typography>
                        </Grid>
                    </Grid>
                </DialogContentText>
                <DialogActions>
                    <Button className={classes.dialogNeutral} onClick={() => { setError([]); onClose() }}>Cancel</Button>
                    <Button className={classes.dialogConfirm} onClick={(event) => handleSubmit(event)} variant="contained" startIcon={<CheckBoxOutlinedIcon />} disabled={!anyErrors(error) || isRequiredFieldEmpty}>SAVE</Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    )
}
